module.exports = __webpack_public_path__ + "assets/img/inndot.d51cde3b.png";